// react
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// third-party
import PropTypes from 'prop-types';

import Departments from './Departments';
// application
import CartIndicator from './IndicatorCart';

function NavPanel(props) {
    const { layout } = props;

    let departments = null;

    if (layout === 'default') {
        departments = (
            <div className="nav-panel__departments">
                <Departments />
            </div>
        );
    }

    return (
        <div className="nav-panel">
            <div className="nav-panel__container container">
                <div className="nav-panel__row">
                    {departments}
                    <button type="button" className="departments__button">
                        <Link to="/liveCasino" className="indicator__button">
                            Live Casino
                        </Link>
                    </button>
                    <button type="button" className="departments__button">
                        <Link to="/sports" className="indicator__button">
                            Sports
                        </Link>
                    </button>
                    <div className="departments__cart">
                        <CartIndicator />
                    </div>
                </div>
            </div>
        </div>
    );
}

NavPanel.propTypes = {
    /** one of ['default', 'compact'] (default: 'default') */
    layout: PropTypes.oneOf(['default', 'compact']),
};

NavPanel.defaultProps = {
    layout: 'default',
};

const mapStateToProps = (state) => ({
    wishlist: state.wishlist,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NavPanel);
